import React from 'react';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label?: React.ReactNode;
    containerClassName?: string;
}

export default function Checkbox({ label, containerClassName = '', className = '', ...props }: CheckboxProps) {
    return (
        <label className={`flex cursor-pointer items-start gap-2.5 ${containerClassName}`}>
            <input
                type="checkbox"
                className={`mt-0.5 h-4 w-4 shrink-0 cursor-pointer rounded border border-[#D2D2D2] accent-[#151515] outline-none transition-colors ${className}`}
                {...props}
            />
            {label && <span className="text-xs leading-relaxed text-[#52525B] sm:text-sm">{label}</span>}
        </label>
    );
}

export type { CheckboxProps };
